import { DogHistory } from "container/DogHistory";
import { useLocation } from "react-router-dom";

export const AdminDogHistory = () => {
  const location = useLocation();
  const { dogId, newDogId } = location.state || {};

  return <DogHistory isAdmin dogId={dogId} newDogId={newDogId} />;
};
